import React from 'react';
import './App.css';
// fonts
import { doc, getDoc, getFirestore } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import './styles/fonts.css';
import './translations/config';

import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { BrandingFooter, Center } from './components';
import { firebaseConfig } from './firebase';
import { StatusView, ValidationView } from './views';
import { useTranslation } from 'react-i18next';
// @ts-ignore
import detectBrowserLanguage from 'detect-browser-language';

const LANG_CODES = ['en', 'da', 'es', 'no', 'se', 'fo', 'de'];
const TIME_RESTRICTED_IDS = [
  // 'acct_c4e7d2f5-7a7e-5d11-9c44-7dd4dbf0e93e', // testing
  'acct_6048f26f-b694-5d5f-aec9-0758cad0da82', // Brædstrup (21-05)
];

/**
 * Hack to restric Brædstrup payments between 21:00 and 05:00 (incl. of 21, excl. of 5)
 */
const isRestrictedTime = () => {
  const now = new Date();
  const danishTime = new Date(
    now.toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' }),
  );
  const hour = danishTime.getHours();
  return hour >= 21 || hour < 5;
};

const App = () => {
  const { i18n } = useTranslation();
  const { paymentLinkId } = useParams();
  const [error, setError] = React.useState(false);
  const [canceled, setCanceled] = React.useState(false);
  const [paid, setPaid] = React.useState(false);
  const [isRestricted, setisRestricted] = React.useState(false);

  const findDocument = async () => {
    if (!paymentLinkId) return;
    // console.log('---> This is the paymentLinkId', paymentLinkId);
    const docRef = doc(firestore, 'paymentlink', paymentLinkId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      // Hack for Brædstrup
      const restricted =
        isRestrictedTime() && TIME_RESTRICTED_IDS.includes(data?.accountId);
      if (data.canceled) {
        // console.log('Link has been canceled!');
        setCanceled(true);
      } else if (data?.paymentStatus === 'paid') {
        setPaid(true);
      } else if (restricted) {
        setisRestricted(restricted);
      } else {
        window.location.href = data.quickpayUrl;
      }
    } else {
      // doc.data() will be undefined in this case
      // console.log('No such document!');
      setError(true);
    }
  };

  /**
   * Detect language in browser and set language
   */
  const setLanguage = () => {
    const browserLanguage = detectBrowserLanguage();

    if (browserLanguage) {
      const langCode = browserLanguage?.split('-')[0];
      LANG_CODES.includes(langCode)
        ? i18n.changeLanguage(langCode)
        : i18n.changeLanguage('en');
    }
  };

  React.useEffect(() => {
    findDocument();
    setLanguage();
  }, []);

  if (error) {
    return (
      <Center>
        <StatusView status="unavailable"></StatusView>
        <BrandingFooter></BrandingFooter>
      </Center>
    );
  }
  if (canceled) {
    return (
      <Center>
        <StatusView status="canceled"></StatusView>
        <BrandingFooter></BrandingFooter>
      </Center>
    );
  }
  if (paid) {
    return (
      <Center>
        <StatusView status="success"></StatusView>
        <BrandingFooter></BrandingFooter>
      </Center>
    );
  }
  if (isRestricted) {
    return (
      <Center>
        <StatusView status="restricted"></StatusView>
        <BrandingFooter></BrandingFooter>
      </Center>
    );
  }
  return (
    <Center>
      <ValidationView></ValidationView>
      <BrandingFooter></BrandingFooter>
    </Center>
  );
};

export const firebase = initializeApp(firebaseConfig);
export const firestore = getFirestore(firebase);

getAnalytics(firebase);

export default App;
